// extracted by mini-css-extract-plugin
export default {"img_box":"SixCheckList_img_box__Tq-2m","img":"SixCheckList_img__DDVFt","inner":"SixCheckList_inner__v2Dxh","text":"SixCheckList_text__pm4G7"};